module.exports = __webpack_public_path__ + "img/type-SAQs.2449da87.svg";